module.exports = __webpack_public_path__ + "img/1-2.92a78024.png";